import { FC, useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCurrentPatient } from '../../../../../hooks/utils'
import { UrlSearchParams } from '../../../../../model/Navigation'
import { Icon, IconButton } from '../../../../shared'
import {
  EventDocHeaderProps,
  EventDocumentType,
} from './PatientTransversalNavigationEventDocHeader.model'
import styles from './PatientTransversalNavigationEventDocHeader.module.scss'

export const PatientTransversalNavigationEventDocHeader: FC<EventDocHeaderProps> = ({
  id,
  title,
  icon,
  type,
  isEventEditable,
  onPrint,
  isOpenable = true,
  isPrinting = false,
  isDisabled = false,
}: EventDocHeaderProps) => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const { currentPatient } = useCurrentPatient()
  const eventId = params.get(UrlSearchParams.eventId)

  const handleFileClick = useCallback(() => {
    const params = type === EventDocumentType.Document ? `docId=${id}` : `fileId=${id}`
    if (currentPatient) {
      // no need to pass the current URL along: the navigation origin tracker records it, and unlike
      // location.state it survives a reload of the medical event page
      navigate(`/patients/${currentPatient.id}/medicalEvent/${eventId}?${params}`)
    }
  }, [currentPatient, eventId, id, navigate, type])

  return (
    <div>
      <div className={styles.fileHeader}>
        <div className={styles.fileNameWithTypeIcon}>
          <div className={styles.fileIcon}>
            <Icon icon={icon} size="nano" />
          </div>
          <h5 className={styles.fileName}>{title}</h5>
        </div>
        {isOpenable && (
          <div className={styles.iconsContainer}>
            <IconButton
              icon={isEventEditable ? 'editFile' : 'eye'}
              theme="transparent-dark"
              onClick={handleFileClick}
              title={isEventEditable ? 'Éditer le fichier' : 'Consulter le fichier'}
              size="micro"
              testId={`button-medical_event-document-${isEventEditable ? 'edit' : 'display'}`}
            />
            {onPrint && (
              <IconButton
                disabled={isDisabled}
                isLoading={isPrinting}
                icon="print"
                theme="primary"
                onClick={onPrint}
                title="Imprimer le fichier"
                size="micro"
                testId="button-medical_event-document-print"
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
